<template>
  <v-card class="mx-auto tw-py-3 tw-px-0" outlined>
    <div class="tw-flex tw-flex-wrap tw-space-x-3 md:tw-space-x-10 tw-items-center tw-px-2 md:tw-px-8">
      <div class="tw-flex tw-flex-col md:tw-border-r-2 tw-border-gray-300 tw-w-full md:tw-w-4/6">
        <div class="tw-flex tw-flex-col md:tw-flex-row">
          <div class="tw-flex md:tw-block tw-px-2 tw-justify-between tw-w-full md:tw-w-auto tw-mb-3 md:tw-mb-0">
            <v-switch v-model="checked" class="tw--mb-5 tw-text-sm tw-z-30" dense>
              <template v-slot:label>
                <small :class="checked ? 'c-navy-text' : ''">Optional Cover</small>
              </template>
            </v-switch>
            <h2 :class="['tw-font-bold', checked ? 'c-navy-text' : 'c-gray-text']">OPTICAL</h2>
          </div>
          <div class="tw-px-0 md:tw-px-8">
            <p class="tw-text-sm c-gray-text">This helps pay for costs associated with outpatient eye care</p>
          </div>
        </div>
        <div class="tw-pr-0 md:tw-pr-8 tw-mt-4 tw-flex tw-flex-wrap tw-justify-between">
          <v-btn v-for="r in limits" :key="r.value" class="tw-mt-4" :color="optical_limit === r.value && checked ? 'primary' : 'default'" :disabled="!checked" @click="addLimit(r.value)"><span :class="optical_limit === r.value ? 'tw-font-bold' :  !checked ? 'tw-font-bold' : 'c-blue-text tw-font-bold'">{{ r.label }}</span></v-btn>
        </div>
      </div>
      <div>
        <h2 v-if="checked" :class="['tw-font-bold tw-text-xl tw-mt-5 md:tw-mt-0', checked ? 'c-navy-text' : 'c-gray-text']" >LIMIT:Ksh{{optical_limit | formatNum}} per person</h2>
        <h2 v-else :class="['tw-font-bold tw-text-xl tw-mt-5 md:tw-mt-0', checked ? 'c-navy-text' : 'c-gray-text']" >LIMIT: Ksh 0</h2>
      </div>
    </div>
  </v-card>
</template>

<script>
import helpers from '@/utils/helpers';

export default {
  name: 'Optical',
  props: ['isChecked'],
  data(vm) {
    return {
      optical_limit: vm.$store.getters['rfq/getHealthQuote'].optical_limit || 10000,
      limits: [
        {
          label: 'KSH 10,000',
          value: 10000,
        },
        {
          label: 'KSH 20,000',
          value: 20000,
        },
        {
          label: 'KSH 30,000',
          value: 30000,
        },
      ],
      checked: this.isChecked,
    };
  },
  watch: {
    checked(val) {
      this.addLimit(val ? 10000 : undefined);
    },
  },
  methods: {
    addLimit(val) {
      this.optical_limit = val;
      this.$store.commit('rfq/setHealthQuotation', { optical_limit: val });
    },
  },
  filters: {
    formatNum(num) {
      return helpers.numberToString(num || 10000);
    },
  },
};
</script>
